import { API_BASE_URL, VetServiceProxy } from './service-proxies';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf, throwError } from 'rxjs';
import { Inject, Optional, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponseBase } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class VetExtendedServiceProxy extends VetServiceProxy {
    
  private httpClient: HttpClient;
  private singleCustomerBaseUrl: string;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl: string) {
    super(http, baseUrl);
    this.httpClient = http;
    this.singleCustomerBaseUrl = baseUrl;
  }

  uploadPictureToVet(file: File | undefined): Observable<string> {
    
    let url_ = environment.vetServiceUrl + '/api/services/app/File/Upload';

    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();

    if (file !== null && file !== undefined) 
        content_.append('formFile', file, file.name ? file.name : 'file');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({ Accept: 'text/plain' }),
    };

    return this.httpClient
      .request('post', url_, options_)
      .pipe(_observableMergeMap((response_: any) => { return this.processUploadPicture(response_)}))
      .pipe(_observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadPicture(<any>response_);
            } catch (e) {
              return <Observable<string>>throwError(() => e);
            }
          } else {
            return <Observable<string>>throwError(() => response_);
          }
        })
      );
  }

  /**
   * Marca la mascota como fallecida. Se llama a Vet/UpdatePet con { deceased:true,
   * customerId } y el backend deriva a Pet/SetDecaesed (la API de Vet ignora
   * 'deceased' en un update normal). Se usa UpdatePet (no un endpoint nuevo) para
   * heredar su permiso ABP. customerId = pet.owners[0].id (id del cliente en Vet).
   */
  markPetDeceased(petId: number, customerId: number): Observable<any> {

    let url_ = this.singleCustomerBaseUrl + '/api/services/app/Vet/UpdatePet';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: JSON.stringify({ id: petId, deceased: true, customerId }),
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({ 'Content-Type': 'application/json-patch+json', Accept: 'text/plain' }),
    };

    return this.httpClient.request('put', url_, options_);
  }

}
